<script>
import AppLoading from "@/components/elements/AppLoading.vue";
import {mapActions, mapGetters} from "vuex";
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import {AiService} from "@/services/AiService";
import TypeWriter from "@/components/common/TypeWriter.vue";

export default {
  name: "AIChatBoxForAccidentIncident",
  components: {TypeWriter, AppLoading},
  data() {
    return {
      rankIdMaster: 1, // for capt/master
      rankIdCE: 2,
      elite_icon: require('@/assets/ai-icons/kirbi.svg'),
      ai_brain: require('@/assets/ai-icons/kirbi.svg'),
      conversations : [],
      current_question : '',
      questionTextArea : null,
      gptModel : 'elite_ai-1.1',
      isElite : true
    }
  },
  methods : {
    ...mapActions([
      'getAccidentIncidentReport',
      'getCrewKeys',
      'getVesselDetail',
      'getAilmentKeys',
      'getAilmentPartKeys',
      'getCompanyInstructions',
    ]),
    hideModal() {
      $('#accident-incident-main-report').modal('hide')
    },
    async requestQuestion() {
      if (this.current_question.trim() === '') {
        return;
      }
      let question = this.current_question;
      this.current_question = '';
      this.questionTextArea.blur();

      setTimeout(() => {
        this.questionTextArea.focus();
      }, 1000)

      this.conversations.push({
        role : 'user',
        content : question.trim(),
        requesting : false,
        error_timer: null,
        model_used : this.gptModel,
        thread : null
      });

      await this.processAssistantRequest();
    },
    async processAssistantRequest() {
      this.conversations.push({
        role : 'assistant',
        content: '',
        requesting : true,
        error_timer: null,
        model_used : this.gptModel,
        thread : null
      })

      const response = await AiService.sendChatCompletions({
        model : this.gptModel,
        messages : this.conversations.filter(item => {
          return item.requesting === false;
        }).map(item => {
          return {
            role : item.role,
            content : item.content
          }
        })
      });
      const conversationLength = this.conversations.length;

      if (response) {
        this.conversations[conversationLength - 1].requesting = false;
        let content = '';

        if (this.isElite === true) {
          this.conversations[conversationLength - 1].role = response?.message?.role;
          content = response?.message?.content?.replace(/\\n/g, '\n');
        } else {
          this.conversations[conversationLength - 1].role = response?.choices[0]?.message?.role;
          content = response?.choices[0]?.message?.content?.replace(/\\n/g, '\n');
        }

        this.conversations[conversationLength - 1].content = DOMPurify.sanitize(marked(content));
      } else {
        let timer = 60;
        this.conversations[conversationLength - 1].thread = setInterval(() => {
          this.conversations[conversationLength - 1].requesting = false;
          this.conversations[conversationLength - 1].error_timer = timer;
          if (timer === 0) {
            return clearInterval(this.conversations[conversationLength - 1].thread);
          }
          timer--;


        }, 1000)

      }
    },
    setTextAreaHeightAndScroll() {
      this.questionTextArea.css({
        height : 'auto'
      });
      this.questionTextArea.css({
        height : this.questionTextArea[0].scrollHeight + 'px'
      });

      if (this.questionTextArea[0].scrollHeight >= 100) {
        this.questionTextArea.css({
          overflowY : 'visible'
        });
      } else {
        this.questionTextArea.css({
          overflowY : 'hidden'
        });
      }
    },
    async setQuestionInputEventHandler() {
      let _this = this;
      let submitted = false;
      this.questionTextArea = $(this.$refs['user-question-area']);
      this.questionTextArea = $(this.$refs['user-question-area']);

      this.questionTextArea.on('keydown', function(event) {
        if (event.keyCode === 13) {
          if (event.shiftKey === false) {
            if (_this.current_question === '') {
              event.preventDefault();
            } else {
              if (submitted === false) {
                _this.requestQuestion(this.current_question);
                submitted = true;
              } else {
                event.preventDefault();
              }
            }
          } else {
            submitted = false;
          }
        } else {
          submitted = false;
        }
        _this.setTextAreaHeightAndScroll();
      });

      this.questionTextArea.on('keyup', function (event) {
        if (event.keyCode === 13) {
          if (event.shiftKey === false) {
            if (_this.current_question === '') {
              event.preventDefault();
            }
          }
        }
        _this.setTextAreaHeightAndScroll();
      });
    },
    async setDeveloperPrompt() {
      await this.getAccidentIncidentReport(this.$route.params.id)
      let crewListParam = {
        onboard_from: this.accidentIncidentReport.event_date,
        onboard_to: this.accidentIncidentReport.event_date,
        vesselName: this.accidentIncidentReport.vessel,
      }

      swal.showLoading()
      await this.getCrewKeys(crewListParam);
      await this.getVesselDetail(this.accidentIncidentReport.vessel_id);
      await this.getAilmentKeys();
      await this.getAilmentPartKeys();
      await this.getCompanyInstructions({type:'air',id:this.$route.params.id});

      let newAccidentIncidentReport = Object.assign({}, this.accidentIncidentReport);
      delete newAccidentIncidentReport.last_updated_by.roles_permissions;
      newAccidentIncidentReport.chief_engineer = this.chiefEngineer[0]?? {};
      newAccidentIncidentReport.master = this.master[0] ?? {};
      newAccidentIncidentReport.crew_numbers = this.manningCrewCount;
      newAccidentIncidentReport.total_crew_onboard = this.manningFromOnboard;
      newAccidentIncidentReport.ship_particular = this.vessel;

      this.conversations.push({
        role : 'developer',
        content: `
          You are a very helpful assistant.
          You will answer the user's question nicely and creatively based on this accident incident report.

          Don't explain programatically in the user such as this variable is empty and so on.

          After you answer the user's question, suggest him or her for any follow-up questions or recommendation.

          This is now the context for the questions:

          Accident Incident Json Data:
          ${JSON.stringify(this.dataPrompt)}
          `,
        requesting : false,
        error_timer : null,
        model_used : this.gptModel,
        thread : null
      })
    },
    async retryQuestion() {
      const conversationLength = this.conversations.length;
      clearInterval(this.conversations[conversationLength - 1].thread);

      this.conversations.pop();
      await this.processAssistantRequest();
    },
    convertHtmlToStringOnly(htmlString) {
      if (htmlString) {
        const withoutTags = htmlString.replace(/<[^>]+>/g, '');
        return withoutTags.replace(/&nbsp;/g, ' ').trim();
      }
      return '';
    }
  },
  computed : {
    ...mapGetters([
      'user',
      'accidentIncidentReport',
      'crewKeys',
      'manningFromOnboard',
      'manningCrewCount',
      'vessel',
      'ailmentKeys',
      'ailmentPartKeys',
      'companyInstructions',
    ]),
    messages() {
      return this.conversations.filter((item, index) => {
        return index > 0;
      }).map(item => {
        return {
          text : item.content,
          role : item.role,
          requesting : item.requesting,
          error_timer : item.error_timer,
          model_used : item.model_used
        }
      })
    },
    master() {
      return Object.values(this.crewKeys).filter((crew) => crew.rank_id == this.rankIdMaster);
    },
    chiefEngineer() {
      return Object.values(this.crewKeys).filter((crew) => crew.rank_id == this.rankIdCE);
    },
    dataPrompt() {
      return {
        general_details : {
          report_number : this.accidentIncidentReport?.code,
          report_status : this.accidentIncidentReport?.report_status,
          vessel_name : this.accidentIncidentReport?.vessel,
          event_class : this.accidentIncidentReport?.eventClass,
          report_title : this.accidentIncidentReport?.title,
          is_confidential : this.accidentIncidentReport?.is_confidential_report,
          last_updated_by : {
            name : this.accidentIncidentReport?.last_updated_by?.name,
            date : this.accidentIncidentReport?.last_updated_by?.created_at,
          },
          monthly_safety_status : {
            kobe_status : this.accidentIncidentReport?.kobe_status,
            rohq_status : this.accidentIncidentReport?.rohq_status,
            stgt_status : this.accidentIncidentReport?.stgt_status,
          },
          management_branch_company : this.accidentIncidentReport?.managementCompany,
          management_branch_office : this.accidentIncidentReport?.managementOffice,
          person_in_charge : this.accidentIncidentReport?.personInCharge,
          responsible_person : this.accidentIncidentReport?.responsiblePerson,
          report_author : this.accidentIncidentReport?.author,
          event_date : this.accidentIncidentReport?.event_date,
          event_time : this.accidentIncidentReport?.event_time,
          timezone : this.accidentIncidentReport?.timezone,
          event_place : this.accidentIncidentReport?.place,
          latitude : this.accidentIncidentReport?.latitude,
          longitude : this.accidentIncidentReport?.longitude,
          route_from : this.accidentIncidentReport?.route_from,
          route_to : this.accidentIncidentReport?.route_to,
          owner : this.accidentIncidentReport?.owner,
          charterer : this.accidentIncidentReport?.charterer,
          cms_information : {
            masters : this.master?.map(item => {
              return {
                last_name : item?.last_name,
                middle_name : item?.middle_name,
                first_name : item?.first_name,
                age : item?.age,
              }
            }),
            chief_engineers : this.chiefEngineer?.map(item => {
              return {
                last_name : item?.last_name,
                middle_name : item?.middle_name,
                first_name : item?.first_name,
                age : item?.age,
              }
            }),
            crew_numbers : this.manningCrewCount,
            total_crew_onboard : this.manningFromOnboard
          }
        },
        event : {
          details : this.convertHtmlToStringOnly(this.accidentIncidentReport?.event?.event_details),
          code_one : this.accidentIncidentReport?.event?.eventOne,
          code_two : this.accidentIncidentReport?.event?.eventTwo,
          code_three : this.accidentIncidentReport?.event?.eventThree,
          code_four : this.accidentIncidentReport?.event?.eventFour,
          code_five : this.accidentIncidentReport?.event?.eventFive,
        },
        loss : {
          is_delay_schedule : this.accidentIncidentReport?.loss?.is_delay_schedule,
          delay_schedule : {
            sched_day : this.accidentIncidentReport?.loss?.delay_sched_day,
            sched_hour : this.accidentIncidentReport?.loss?.delay_sched_hour,
            sched_minute : this.accidentIncidentReport?.loss?.delay_sched_minute,
            remarks : this.accidentIncidentReport?.loss?.delay_sched_remarks,
          },
          summary : this.accidentIncidentReport?.loss?.lossSummary?.map(item => {
            return {
              name : item?.name,
              amount : item?.amount,
            }
          }),
          estimated_cost : this.accidentIncidentReport?.loss?.estimated_cost,
          personnel : this.accidentIncidentReport?.loss?.personnel?.map(item => {
            return {
              last_name : item?.last_name,
              first_name : item?.first_name,
              middle_name : item?.middle_name,
              personnel_costs : item?.personnel_costs,
              currency : item?.currency,
              lost_details : item?.lost_details,
              medicalType : item?.medicalType,
              extent_of_injuries : item?.medicalSeverity,
              complaint : item?.complaint,
              injuries : item?.ailment_id?.map(id => {
                return this.ailmentKeys?.filter(item => {
                  return item?.id === id;
                })[0]
              })?.map(item => {
                return {
                  name : item?.name
                }
              }),
              injuries_parts : item?.ailment_part_id?.map(id => {
                return this.ailmentPartKeys?.filter(item => {
                  return item?.id === id;
                })[0]
              })?.map(item => {
                return {
                  name : item?.name
                }
              }),
              medicalTreatment : item?.medicalTreatment,
              ailmentReason : item?.ailmentReason,
              ailment_details : item?.ailment_details,
            }
          }),
          hull_and_machinery : {
            hm_status : this.accidentIncidentReport?.loss?.hm_status === 2 ? 'Occurred' : 'N/A',
            cost : this.accidentIncidentReport?.loss?.hm_cost,
            cost_details : this.accidentIncidentReport?.loss?.hm_cost_details,
            cost_currency : this.accidentIncidentReport?.loss?.hmCurrency,
            equipment_manufacturer : this.accidentIncidentReport?.loss?.hm_equipment_manufacturer,
            equipment_model : this.accidentIncidentReport?.loss?.hm_equipment_model,
            part_number : this.accidentIncidentReport?.loss?.hm_part_number,
          },
          cargo_damage: {
            cd_status : this.accidentIncidentReport?.loss?.cd_status === 2 ? 'Occurred' : 'N/A',
            cost_currency : this.accidentIncidentReport?.loss?.cdCurrency,
            cost : this.accidentIncidentReport?.loss?.cd_cost,
            cost_details : this.accidentIncidentReport?.loss?.cd_cost_details,
          },
          environmental: {
            e_status : this.accidentIncidentReport?.loss?.e_status === 2 ? 'Occurred' : 'N/A',
            cost_currency : this.accidentIncidentReport?.loss?.eCurrency,
            cost : this.accidentIncidentReport?.loss?.e_cost,
            cost_details : this.accidentIncidentReport?.loss?.e_cost_details,
          },
          third_party: {
            tp_status : this.accidentIncidentReport?.loss?.tp_status === 2 ? 'Occurred' : 'N/A',
            cost_currency : this.accidentIncidentReport?.loss?.tpCurrency,
            cost : this.accidentIncidentReport?.loss?.tp_cost,
            cost_details : this.accidentIncidentReport?.loss?.tp_cost_details,
          }
        },
        cause : {
          immediate_cause : {
            substandard_act : this.accidentIncidentReport?.cause?.immediateCause,
            substandard_condition : this.accidentIncidentReport?.cause?.immediateCauseSubCon,
            cause_detail : this.convertHtmlToStringOnly(this.accidentIncidentReport?.cause?.immediate_cause_details),
          },
          root_cause : {
            root_cause : this.accidentIncidentReport?.cause?.rootCause,
            factor : this.accidentIncidentReport?.cause?.rootCauseFactor,
            root_cause_details : this.convertHtmlToStringOnly(this.accidentIncidentReport?.cause?.root_cause_details),
          },
          human_error_classification : {
            human_error_personal : this.accidentIncidentReport?.cause?.humanErrorPersonal,
            human_error_managing : this.accidentIncidentReport?.cause?.humanErrorManning,
            human_error_third_party : this.accidentIncidentReport?.cause?.humanErrorThirdParty,
          }
        },
        corrective_action: {
          root_cause : {
            root_cause : this.accidentIncidentReport?.cause?.rootCause,
            factor : this.accidentIncidentReport?.cause?.rootCauseFactor,
          },
          preparation_of_corrective_actions : {
            instruction_to_the_master : this.convertHtmlToStringOnly(this.accidentIncidentReport?.corrective?.rootCauseFactor),
            date_of_instruction : this.accidentIncidentReport?.corrective?.instruction_date,
            instructed_by : this.accidentIncidentReport?.personInCharge
          },
          action_taken : {
            action_taken_by_management_or_master : this.convertHtmlToStringOnly(this.accidentIncidentReport?.corrective?.action_taken),
            action_taken_date : this.accidentIncidentReport?.corrective?.action_taken_date,
            reported_by : this.accidentIncidentReport?.corrective?.reported_by
          }
        },
        verification_of_effectiveness_of_corrective_action : {
          is_corrective_action_affective : this.accidentIncidentReport?.corrective?.is_corrective_action_affective === 1 ? 0 : 1,
          is_corrective_action_effective : this.accidentIncidentReport?.corrective?.is_corrective_action_effective,
          is_effectiveness_of_corrective_action_confirmed : this.accidentIncidentReport?.corrective?.is_verified_corrective_action,
          designated_person : 'Takimoto , S.',
          person_in_charge : this.accidentIncidentReport?.personInCharge,
        },
        preventative_measures: {
          detail : this.convertHtmlToStringOnly(this.accidentIncidentReport?.preventive?.details),
          related_equipment : this.accidentIncidentReport?.preventive?.equipment,
          related_procedures : this.accidentIncidentReport?.preventive?.procedures,
          for_risk_assessment : this.accidentIncidentReport?.preventive?.for_risk_assessment,
          for_shore_training : this.accidentIncidentReport?.preventive?.for_shore_training,
        },
        companyInstructions: this.companyInstructions,
        ship_particular : {
          ship_name : this.vessel?.name,
          active : this.vessel?.active,
          abbreviation : this.vessel?.abbreviation,
          previous_names : this.vessel?.previous_names,
          ship_type : this.vessel?.vessel_type_name,
          imo_no : this.vessel?.imo_no,
          call_sign : this.vessel?.call_sign,
          flag_name : this.vessel?.flag_name,
          mmsi : this.vessel?.mmsi,
          class : this.vessel?.class,
          class_no : this.vessel?.class_no,
          classification_characters : this.vessel?.classification_characters,
          installation_characters : this.vessel?.installation_characters,
          assigned_mannings : this.vessel?.mannings?.map(item => {
            return {
              alias : item?.alias,
              name : item?.name
            }
          }),
          tonnage_gross_international : this.vessel?.tonnage_gross_international,
          tonnage_gross_registered : this.vessel?.tonnage_gross_registered,
          dead_weight : this.vessel?.dead_weight,
          summer_freeboard : this.vessel?.summer_freeboard,
          summer_draft : this.vessel?.summer_draft,
          loa : this.vessel?.loa,
          moulded_lbd : this.vessel?.moulded_lbd,
          registered_lbd : this.vessel?.registered_lbd,
          shipbuilder : this.vessel?.shipbuilder,
          hull_number : this.vessel?.hull_number,
          sister_ship_of : this.vessel?.sister_ship_of,
          date_contract : this.vessel?.date_contract,
          date_keel_lay : this.vessel?.date_keel_lay,
          date_launch : this.vessel?.date_launch,
          date_build : this.vessel?.date_build,
          age : this.vessel?.age,
          main_engine : {
            engine_maker : this.vessel?.engine_maker,
            engine_type : this.vessel?.engine_type
          },
          diesel_generator : {
            engine_dg_maker : this.vessel?.engine_dg_maker,
            engine_dg_type : this.vessel?.engine_dg_type
          },
          turbo_changer : {
            engine_tc_maker : this.vessel?.engine_tc_maker,
            engine_tc_type : this.vessel?.engine_tc_type,
          },
          auxiliary_boiler : {
            engine_aux_maker : this.vessel?.engine_aux_maker,
            engine_aux_type : this.vessel?.engine_aux_type,
          },
          ism_management_company : this.vessel?.management_company_name,
          management_branch_office : this.vessel?.management_office_name,
          fleet_name : this.vessel?.fleet_name,
          registered_owner_one : this.vessel?.registered_owner_one,
          registered_owner_two : this.vessel?.registered_owner_two,
          bbc_owner_one : this.vessel?.bbc_owner_one,
          bbc_owner_two : this.vessel?.bbc_owner_two,
          email_address : this.vessel?.email_address,
          tel_vsat_direct_phone : this.vessel?.tel_vsat_direct,
          tel_inmarsat_fbb_phone : this.vessel?.tel_inmarsat_fbb,
          tel_vsat_ship_office_phone : this.vessel?.tel_vsat_ship_office,
          fax_inmarsat_fbb : this.vessel?.fax_inmarsat_fbb,
          inmarsat_c : this.vessel?.inmarsat_c,
          mobile_in_port_only : this.vessel?.mobile,
        }
      }
    }
  },
  async created() {
    this.questionTextArea = $(this.$refs['user-question-area']);
    await this.setDeveloperPrompt();
    // this.conversations.push({
    //   role : 'user',
    //   content : `Hello, I am ${this.user.name}. I have a query regarding this accident incident report`,
    //   requesting : false,
    //   error_timer : null,
    //   model_used : this.gptModel,
    //   thread : null
    // })

    setTimeout(() => {
      this.setQuestionInputEventHandler();
    }, 1000);
  }
}
</script>

<template>
  <div class="chatBox modal fade text-left" data-backdrop="static" data-keyboard="false" id="accident-incident-main-report">
    <form @submit.prevent="">
      <div class="modal-dialog modal-xl modal-dialog-centered" >
        <div class="modal-content">
          <div class="modal-header py-2">
            <div class="w-100 d-flex align-items-center">
              <img :src="ai_brain" alt="" style="height: 45px; width: 45px" class="mr-1">
              <h5 class="font-weight-bold">Accident Incident Main Report</h5>
            </div>
<!--            <select name="" id="" style="width: auto" class="float-left form-control form-control-sm" v-model="gptModel">-->
<!--              <option :selected="gptModel === 'gpt-4.1'" value="elite_ai-1.1"> eliteAI-1.1</option>-->
<!--              <option :selected="gptModel === 'gpt-4.1-mini'" value="elite_ai-1.1-mini"> eliteAI-1.1-mini</option>-->
<!--              <option :selected="gptModel === 'gpt-4o-mini'" value="elite_ai-1.2"> eliteAI-1.2</option>-->
<!--            </select>-->
            <button type="button" class="close" @click="hideModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body d-flex" id = "modal-conversation" style="max-height: 80vh; overflow-y: auto">
            <div class="conversation flex-grow-1 pr-2">
              <template v-for="(item, index) in messages">
                <div class="card shadow-sm p-3 question" v-if="item.role === 'user'">
                  {{ item.text }}
                </div>
                <template v-else>
                  <div class="py-3 w-100 flex-row answer">
                    <div class = "mr-2" style="width: 5%">
                      <img :src="elite_icon" alt="" style="height: 40px; width: 40px">
                    </div>
                    <div class="card shadow-sm p-3 answer w-100">
                      <template v-if="item.requesting === true">
                        <div class="circle-dots-loading">
                          <span>●</span><span>●</span><span>●</span>
                        </div>
                      </template>
                      <template v-else>
                        <template v-if="item.error_timer !== null">
                          <span>
                            <span style="color: red">There's an error from the server</span>
                             <button
                               class="ml-1"
                               @click="retryQuestion()"
                               :disabled="(item.error_timer === 0 || item.model_used !== gptModel) === false"
                               :style="{ cursor : item.error_timer === 0 || item.model_used !== gptModel ? '' : 'not-allowed'}"
                               style="
              padding: 5px 8px;
              border-radius: 8px;
              background-color: #f0f0f0;
              border: 1px solid #ccc;
              cursor: pointer;
            ">
                             🔄 Try Again {{ item.error_timer === 0 || item.model_used !== gptModel ? '' : `(${item.error_timer}s)`}}
                              </button>
                          </span>
                        </template>
                        <TypeWriter
                          v-else
                          :html-content="item.text"
                        />
                      </template>
                    </div>
                  </div>
                </template>
<!--                <div class="card shadow-sm p-3 question" v-if="question.visible === true">-->
<!--                  {{ question.value }}-->
<!--                </div>-->
<!--                <template v-if="answers[index].value !== undefined">-->
<!--                  <div class="py-3 w-100 flex-row answer">-->
<!--                    <div class = "mr-2" style="width: 5%">-->
<!--                      <img :src="elite_icon" alt="" style="height: 40px; width: 40px">-->
<!--                    </div>-->

<!--                    <div class="card shadow-sm p-3 answer w-100" v-if="answers[index].requesting === false">-->
<!--                      <TypeWriter-->
<!--                        v-if="answers[index].value !== ''"-->
<!--                        :html-content="answers[index].value"-->
<!--                        @doneWriting="showDownloadButton(index)"-->
<!--                      />-->

<!--                      <div class="w-full" v-if="answers[index].fetching_record" style="opacity: 0.7">-->
<!--                        <i class="loading-text" v-if="answers[index].fetching_record === 'Still working on it... almost there!'">-->
<!--                          {{ answers[index].fetching_record }}-->
<!--                        </i>-->
<!--                        <i v-else class="loading-text">{{ answers[index].fetching_record }}{{ parseInt((processedAssistant / (Object.keys(ai_accident_incidents.helper_fields).length)) * 100) }}%)</i>-->
<!--                      </div>-->

<!--                      <div class="w-full mt-2" v-if="answers[index].show_dl_button">-->
<!--                        <button class="float-right e-btn e-btn-blue-gray force-white-all"-->
<!--                                :disabled="answers[index].download_processing === true"-->
<!--                                :class="answers[index].download_processing === true ? 'e-btn-blue-gray-disabled' : ''"-->
<!--                                @click="downloadResultToExcel(index)"-->
<!--                                type="button">-->
<!--                          Download Reports-->
<!--                        </button>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="card shadow-sm p-3 answer w-100" v-else>-->
<!--                      <div class="flex-row align-middle">-->
<!--                        <AppLoading :spinner-only="true" :height="'20px'" :width="'20px'"/>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                </template>-->
              </template>
            </div>
          </div>
          <div class="modal-footer">
            <div class="w-100 d-flex align-items-center p-3 input-and-button-area position-relative">
              <textarea type="text" :disabled="conversations.length === 0" v-model="current_question" ref="user-question-area" class="question-area form-control-sm" name="" id="user-question-area"></textarea>
              <div class="button-area text-center">
                <button @click="requestQuestion(current_question)" id="send_question_btn" :disabled="current_question.trim() === ''" :class="[current_question.trim() === '' ? '' : 'active-question-btn']">
                  <font-awesome-icon icon="arrow-up" class="arrow-up e-text-white"/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>

<style scoped>
.chatBox {
  color: white;
  padding: 10px 10px;
  cursor: pointer;
  width: 99%;
  z-index: 10000;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.modal-content {
  height: 90vh;

}

.conversation {
  overflow-y: auto;
  width: 100%;
  padding-right: 1rem;
  overflow-wrap: break-word; /* prevents long words from overflowing */
}


.question {
  max-width: 80%;
  float: right;
  white-space: pre-wrap;
  background-color: #f4f4f4;
}


.answer {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background-color: #fff;
  background-clip: border-box;
  border-radius: .25rem;
  font-family: monospace;
}

.question-area {
  resize: none;
  min-height: 50px;
  max-height: 25dvh;
  overflow-y: hidden;
}

.arrow-up {
  font-size: 15px;
  color: white;
}

#user-question-area {
  width: 95%;
  border: none !important;
  background-color: #f4f4f4;
  outline: none !important;
}

#user-question-area:focus {
  outline: none !important;
  border: none !important;
}

.button-area {
  width: 5%;
  position: absolute;
  right: 22px;
  bottom: 29px;
}

.active-question-btn {
  background-color: #478bca !important;
}
#send_question_btn {
  border-radius: 9999px;
  width: 35px;
  height: 35px;
  border: none;
  margin: auto;
  background-color: #d7d7d7;
}
.input-and-button-area {
  background-color:#f4f4f4;
  opacity: 1;
  border-radius: 26px;
}

.related-question-container {
  width: 95%;
  position: absolute;
  bottom: 90px;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.suggested-question:hover {
  background-color: #e9ecef !important;
  color: #435464 !important;
}

.suggested-sidebar {
  width: 250px;
  max-width: 30%;
  background-color: #f8f9fa;
  border-left: 1px solid #dee2e6;
  padding: 1rem;
  overflow-y: auto;
  height: 100%;
  max-height: 67vh;
}

.suggested-sidebar h6 {
  font-size: 1rem;
  margin-bottom: 1rem;
  color: #333;
}

.suggested-question {
  cursor: pointer;
  background-color: #fff;
  border: 1px solid #dee2e6;
  transition: background-color 0.2s ease;
}

.suggested-question:hover {
  background-color: #e9ecef;
  color: #435464;
}

@keyframes loadingLineEffect {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: 0 0;
  }
}

.loading-text {
  font-size: 13px;
  text-align: center;
  display: inline-block; /* Ensures animation only applies to the text */

  /* Transparent text with background gradient */
  color: transparent;
  background-image: linear-gradient(
    90deg,
    black,
    #2c2c2c, /* Dark grey */
    #555555, /* Medium grey */
    #2c2c2c, /* Dark grey */
    black
  );
  background-clip: text;
  -webkit-background-clip: text;

  /* Animate the background position */
  background-size: 200%; /* Makes the gradient "move" across the text */
  animation: loadingLineEffect 0.8s linear infinite; /* Linear effect, infinite loop */
}

.circle-dots-loading {
  font-size: 16px; /* Adjust size here */
  font-family: sans-serif;
  display: inline-block;
  color: #333;
}

.circle-dots-loading span {
  opacity: 0;
  animation: fade 1.5s infinite;
  padding: 0 2px;
}

.circle-dots-loading span:nth-child(1) {
  animation-delay: 0s;
}
.circle-dots-loading span:nth-child(2) {
  animation-delay: 0.2s;
}
.circle-dots-loading span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes fade {
  0%, 100% { opacity: 0; }
  50% { opacity: 1; }
}
</style>
